export const OFFER_REVIEW = 1
